import {
  CssBaseline,
  ThemeProvider
} from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { theme } from './theme';

import { LoadingOverlay } from 'modules';
import { router } from './activities';



function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <RouterProvider router={router} />

      <LoadingOverlay.FC />
    </ThemeProvider>
  );
}

export default App;
